import Player from '@vimeo/player';
import { csrfToken } from 'rails-ujs';

const interval = 10 * 1000; // timer interval: 10 seconds

$(function() {
  initialize();
});

function initialize() {
  $("iframe[id^=player]").each(function() {
    const iframe = this;
    const player = new Player(iframe);

    const movieId = player.element.dataset.movie_id;

    // サンプル視聴ボタンクリック時（このmovieIdに対応するボタンのみ）
    $(`.video-sample-btn[data-movie_id="${movieId}"]`).on("click", function() {
      // 価格体系導線オーバーレイを非表示
      $(`#pricing_flow_overlay_pc_${movieId}`).hide();
      $(`#pricing_flow_overlay_sp_${movieId}`).hide();
      // サンプル動画を再生
      player.play();
    });

    // 目次クリック時 seek at the specified time
    $(".toc_time").on("click", function(e) {
      e.preventDefault();

      // timeText (hh:mm:ss) ex. '1:23:45'
      const timeText = $(this).data('time');
      const [ss = 0, mm = 0, hh = 0]
        = timeText.split(':').map(it => parseInt(it)).reverse();
      // conversion of hours, minutes and seconds to seconds
      const seconds = [ss, (mm * 60), (hh * 60 * 60)]
        .reduce((sum, it) => { return sum + it }, 0);

      player.setCurrentTime(seconds);
    });

    setupPlayerEvents(player);
  });
}

function shouldOpenAd(player) {
  const adModal = document.querySelector('.ad-modal');
  const notSample = (player.element?.dataset.sample !== 'true');
  const notPreview = (player.element?.dataset.preview !== 'true');
  const notIntercepted = !player.intercepted;

  return (adModal && notSample && notPreview && notIntercepted);
}

// 広告インターセプトをカスタムイベントで要求（ad_modal.js が購読）
const AD_INTERCEPT_FALLBACK_MS = 2000;

function requestAdModalIntercept(player) {
  // settled guards: only the first of (event handler | timeout) resolves to prevent double resolution
  let settled = false;
  return new Promise((resolve) => {
    const doResolve = () => {
      if (!settled) {
        settled = true;
        resolve();
      }
    };
    const detail = { player, resolve: doResolve };
    document.dispatchEvent(
      new CustomEvent('adModal:requestIntercept', { detail })
    );
    setTimeout(doResolve, AD_INTERCEPT_FALLBACK_MS);
  });
}

function startPlaybackTracking(player) {
  createLogData(player);
  clearTimer(player);
  setTimer(player);
}

function setupPlayerEvents(player) {
  const movieId = player.element.dataset.movie_id;

  player.intercepted = false;
  player.loggedId = null;
  player.timerId = null;

  // 設定再生位置
  player.setCurrentTime(Number($(`#current_time_${movieId}`).val()));

  // イベントリスナー設定
  window.addEventListener("beforeunload", () => {
    player.pause();
  });
  window.addEventListener("pagehide", () => {
    player.pause();
  });

  player.on("play", async function() {
    // 広告表示が必要な場合、インターセプトを要求 (pause & unload -> open AdModal -> close AdModal -> re-play)
    const interceptRequested = shouldOpenAd(player);
    if (interceptRequested) await requestAdModalIntercept(player);

    // 広告インターセプト成功時は視聴ログ採取をスキップ（広告閉鎖時の play 再発火で tracking される）
    const skipPlaybackTracking = interceptRequested && player.intercepted;
    if (skipPlaybackTracking) return;

    startPlaybackTracking(player);
  });

  // 再生を一時停止した or 再生が終了した時
  //
  // NOTE:
  // - 価格体系導線のオーバーレイは、PC/SP で別々の要素としてrenderされる
  //   - PC版: div#pricing_flow_overlay_pc_${movieId}
  //   - SP版: div#pricing_flow_overlay_sp_${movieId}
  // - サンプル視聴開始時にこれらを非表示にし、pause時に再度表示することで
  //   「動画上に導線が戻る」既存仕様を維持する
  player.on("pause", function() {
    const pcOverlayId = `pricing_flow_overlay_pc_${movieId}`;
    const spOverlayId = `pricing_flow_overlay_sp_${movieId}`;
    const pcOverlay = document.getElementById(pcOverlayId);
    const spOverlay = document.getElementById(spOverlayId);
    if (pcOverlay) pcOverlay.style.display = "";
    if (spOverlay) spOverlay.style.display = "";

    updateLogData(player);
    clearTimer(player);
  });
}

function setTimer(player) {
  player.timerId = setInterval(() => updateLogData(player), interval);
}

function clearTimer(player) {
  if (!player.timerId) return;
  clearInterval(player.timerId);
  player.timerId = null;
}

function createLogData(player) {
  const { loggedId } = player;
  const preview = (player.element.dataset.preview === 'true');

  // 一度送信済み or プレビュー表示の場合は送信しない
  if (loggedId || preview) return;

  $.ajax({
    type: "POST",
    url: "/api/log_movies",
    headers: {
      "X-CSRF-Token": csrfToken(),
    },
    data: {
      movie_id: player.element.dataset.movie_id,
    },
    success: function(data) {
      player.loggedId = data["log_id"];
    },
    async: false,
    timeout: 10000,
  });
}

function updateLogData(player) {
  const { loggedId } = player;
  const preview = (player.element.dataset.preview === 'true');

  if (loggedId == null || preview) return;

  player.getPlayed().then(function(played) {
    if (played == null || played.length == 0) return;

    const durations = played.map((range) => range[1] - range[0]);
    const endPoints = played.map((range) => range[1]);
    const duration = durations.reduce((sum, duration) => sum + duration, 0);
    const currentTime = Math.max(...endPoints);

    $.ajax({
      type: "PUT",
      url: `/api/log_movies/${loggedId}`,
      headers: {
        "X-CSRF-Token": csrfToken(),
      },
      data: {
        duration: duration,
        current_time: currentTime,
      },
      async: false,
      timeout: 10000,
    });
  });
}
